var url = "7ab8dd9e99bfb439e56cfca793f6a045.webp";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;